import { useAppsSectionModel } from './useAppsSectionModel.js'
import AppsSectionView from './AppsSectionView.jsx'

export default function AppsSection(props) {
  return <AppsSectionView {...useAppsSectionModel(props)} />
}
